import { Pipe, PipeTransform } from '@angular/core';
import {
    ReferencedAuthorityDto,
    SimpleAuthorityDto
} from '@flyfreely-portal-ui/flyfreely';
import { FormatDatePipe } from '../generic/formatDate';

export function formatAuthorityTypeName(
    authority: SimpleAuthorityDto | ReferencedAuthorityDto
) {
    if (authority.authorityType == null) {
        return '';
    }
    const name =
        // If the authority type allows custom names and the authority has one, use the custom name
        authority.authorityType.hasName &&
        'name' in authority &&
        authority.name != null
            ? authority.name
            : // Otherwise use either the authority type abbreviation or the authority type name
            authority.authorityType.abbreviation != null
            ? authority.authorityType.abbreviation
            : authority.authorityType.name;
    return name;
}

@Pipe({ name: 'formatAuthority' })
export class FormatAuthorityPipe implements PipeTransform {
    constructor(private formatDate: FormatDatePipe) {}

    transform(
        authority: SimpleAuthorityDto | ReferencedAuthorityDto,
        showDateRange = true,
        nameOnly = false
    ) {
        if (
            authority == null ||
            !(authority instanceof Object) ||
            authority.authorityType == null ||
            authority.organisation == null
        ) {
            return null;
        }

        const authorityName = formatAuthorityTypeName(authority);

        const identifier =
            authority.identifier != null &&
            authority.authorityType.hasIdentifier
                ? `${authority.authorityType.identifierLabel} ${authority.identifier}`
                : '';

        const dateRange =
            this.formatDate.transform(authority.startDate) +
            (authority.expiryDate != null
                ? ` - ${this.formatDate.transform(authority.expiryDate)}`
                : '');

        return showDateRange
            ? `${authority.organisation.name}'s ${authorityName} ${identifier} (${dateRange})`
            : nameOnly
            ? `${authorityName}`
            : `${authority.organisation.name}'s ${authorityName} ${identifier}`;
    }
}
